import styled from "styled-components";

export const _DesignViewContainer = styled.main`
  flex-direction: column;
  display: flex;
  justify-content: space-evenly;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

export const _LayoutSectionDesignView = styled.div`
  position: relative;

  @media (min-width: 768px) {
    width: 45%;
    flex-basis: 50%;
    padding-left: 15px;
    
    &:last-of-type {
      border-left: 1px solid lightgrey;
      padding-left: 30px;
    }
  }


  &:last-child {
    margin-top: 53vh;
    // TODO 2493 (lower prio atm) needs a better solution for e.g. iPhone X + landscape mobile
    @media (min-width: 400px) {
      margin-top: 42vh;
    }
    
    @media (min-width: 480px) {
      margin-top: 59vh;
    }

    @media (min-width: 768px) {
      margin-top: 0;
    }
  }

  // Target form - which are all the options the user is able to makeOption
  & form {
    margin-top: 24vh;

    @media (min-width: 480px) {
      margin-top: 28vh;
    }

    @media (min-width: 768px) {
      // When flex-direction is row and the two containers are next to each other
      margin-top: 0px;
    }
  }
`;
